export default __webpack_public_path__ + "static/media/video2.51c62ffe.webp";